var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 22.7571C18.1659 22.7571 22.6431 18.2799 22.6431 12.7571C22.6431 7.23423 18.1659 2.75708 12.6431 2.75708C7.12022 2.75708 2.64307 7.23423 2.64307 12.7571C2.64307 18.2799 7.12022 22.7571 12.6431 22.7571Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73291 9.75704C9.96801 9.08871 10.4321 8.52515 11.0429 8.16617C11.6537 7.8072 12.3718 7.67598 13.0701 7.79575C13.7684 7.91552 14.4017 8.27856 14.858 8.82057C15.3142 9.36257 15.564 10.0486 15.5629 10.757C15.5629 12.757 12.5629 13.757 12.5629 13.757",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 17.7571H12.6531",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.33f6e75848ebbd7c2ea21fbfbcc852e0.svg";
export { ForwardRef as ReactComponent };